"use strict";
exports.__esModule = true;
exports.transposeScale = exports.isValidNumber = exports.isTiny = exports.buildZeroString = exports.defaultLocale = exports.currencyToSymbol = void 0;
var enums_1 = require("./enums");
exports.currencyToSymbol = {
    XXX: { currency: { symbol: ' ' } },
    AED: { currency: { symbol: 'د.إ' } },
    AMD: { currency: { symbol: 'դր' } },
    ANG: { currency: { symbol: 'NAƒ' } },
    AOA: { currency: { symbol: 'Kz' } },
    ARS: { currency: { symbol: 'AR$' } },
    AUD: { currency: { symbol: 'AU$' } },
    AWG: { currency: { symbol: 'ƒ' } },
    AZN: { currency: { symbol: 'ман' } },
    BAM: { currency: { symbol: 'KM ' } },
    BBD: { currency: { symbol: 'Bds$' } },
    BDT: { currency: { symbol: '৳' } },
    BGN: { currency: { symbol: 'лв' } },
    BHD: { currency: { symbol: 'ب.د' } },
    BIF: { currency: { symbol: 'FBu' } },
    BMD: { currency: { symbol: 'BD$' } },
    BND: { currency: { symbol: 'B$' } },
    BOB: { currency: { symbol: 'Bs' } },
    BRL: { currency: { symbol: 'R$' } },
    BSD: { currency: { symbol: 'BS$' } },
    BTN: { currency: { symbol: 'Nu' } },
    BWP: { currency: { symbol: 'P' } },
    BYR: { currency: { symbol: 'Br' } },
    BZD: { currency: { symbol: 'BZ$' } },
    CAD: { currency: { symbol: 'CA$' } },
    CDF: { currency: { symbol: 'CDFr' } },
    CHF: { currency: { symbol: 'CHF ' } },
    CLP: { currency: { symbol: 'CL$' } },
    CNY: { currency: { symbol: 'CN¥' } },
    COP: { currency: { symbol: 'Col$' } },
    CRC: { currency: { symbol: '₡' } },
    CUC: { currency: { symbol: 'CU$' } },
    CVE: { currency: { symbol: 'CV$' } },
    CYP: { currency: { symbol: 'CY£' } },
    CZK: { currency: { symbol: 'Kč' } },
    DJF: { currency: { symbol: 'Fdj' } },
    DKK: { currency: { symbol: 'DKK ' } },
    DOP: { currency: { symbol: 'RD$' } },
    DZD: { currency: { symbol: 'دج' } },
    EEK: { currency: { symbol: 'kr' } },
    EGP: { currency: { symbol: 'ج.م' } },
    ERN: { currency: { symbol: 'Nkf' } },
    ETB: { currency: { symbol: 'Br' } },
    EUR: { currency: { symbol: '€' } },
    FJD: { currency: { symbol: 'FJ$' } },
    FKP: { currency: { symbol: 'FK£' } },
    GBP: { currency: { symbol: 'UK£' } },
    GBX: { currency: { symbol: 'GBX' } },
    GEL: { currency: { symbol: 'GEL ' } },
    GHC: { currency: { symbol: '₵' } },
    GHS: { currency: { symbol: 'GH₵' } },
    GIP: { currency: { symbol: 'GI£' } },
    GMD: { currency: { symbol: 'D' } },
    GNF: { currency: { symbol: 'FG ' } },
    GTQ: { currency: { symbol: 'Q' } },
    GYD: { currency: { symbol: 'GY$' } },
    HKD: { currency: { symbol: 'HK$' } },
    HNL: { currency: { symbol: 'L' } },
    HRK: { currency: { symbol: 'Kn' } },
    HTG: { currency: { symbol: 'G' } },
    HUF: { currency: { symbol: 'Ft' } },
    IDR: { currency: { symbol: 'Rp' } },
    ILS: { currency: { symbol: '₪' } },
    INR: { currency: { symbol: '₹' } },
    IQD: { currency: { symbol: 'ع.د' } },
    IRR: { currency: { symbol: 'ريال' } },
    ISK: { currency: { symbol: 'ISK ' } },
    JMD: { currency: { symbol: 'JA$' } },
    JOD: { currency: { symbol: 'د.أ' } },
    JPY: { currency: { symbol: 'JP¥' } },
    KES: { currency: { symbol: 'KSh' } },
    KGS: { currency: { symbol: 'С̲ ' } },
    KHR: { currency: { symbol: '៛' } },
    KMF: { currency: { symbol: 'KMF ' } },
    KPW: { currency: { symbol: '₩' } },
    KRW: { currency: { symbol: '₩' } },
    KWD: { currency: { symbol: 'د.ك' } },
    KYD: { currency: { symbol: 'CI$' } },
    KZT: { currency: { symbol: '₸' } },
    LAK: { currency: { symbol: '₭' } },
    LBP: { currency: { symbol: 'ل.ل' } },
    LKR: { currency: { symbol: 'LK₨' } },
    LRD: { currency: { symbol: 'L$' } },
    LSL: { currency: { symbol: 'L' } },
    LTL: { currency: { symbol: 'Lt' } },
    LVL: { currency: { symbol: 'Ls' } },
    LYD: { currency: { symbol: 'ل.د' } },
    MAD: { currency: { symbol: 'د.م' } },
    MDL: { currency: { symbol: 'MDL ' } },
    MGA: { currency: { symbol: 'Ar' } },
    MKD: { currency: { symbol: 'ден' } },
    MMK: { currency: { symbol: 'K' } },
    MNT: { currency: { symbol: '₮' } },
    MOP: { currency: { symbol: 'MO$' } },
    MRO: { currency: { symbol: 'UM ' } },
    MTL: { currency: { symbol: 'Lm' } },
    MUR: { currency: { symbol: 'MU₨' } },
    MVR: { currency: { symbol: 'MRf' } },
    MWK: { currency: { symbol: 'MK ' } },
    MXN: { currency: { symbol: 'Mex$' } },
    MYR: { currency: { symbol: 'RM ' } },
    MZN: { currency: { symbol: 'MTn' } },
    NAD: { currency: { symbol: 'N$' } },
    NGN: { currency: { symbol: '₦' } },
    NIO: { currency: { symbol: 'C$' } },
    NOK: { currency: { symbol: 'NOK ' } },
    NPR: { currency: { symbol: 'NP₨' } },
    NZD: { currency: { symbol: 'NZ$' } },
    OMR: { currency: { symbol: 'ر.ع' } },
    PAB: { currency: { symbol: 'B/' } },
    PEN: { currency: { symbol: 'S/' } },
    PGK: { currency: { symbol: 'K' } },
    PHP: { currency: { symbol: '₱' } },
    PKR: { currency: { symbol: 'PK₨' } },
    PLN: { currency: { symbol: 'zł' } },
    PYG: { currency: { symbol: '₲' } },
    QAR: { currency: { symbol: 'ر.ق' } },
    RON: { currency: { symbol: 'RON ' } },
    RSD: { currency: { symbol: 'дин' } },
    RUB: { currency: { symbol: '₽' } },
    RWF: { currency: { symbol: 'RF ' } },
    SAR: { currency: { symbol: 'ر.س' } },
    SBD: { currency: { symbol: 'SI$' } },
    SCR: { currency: { symbol: 'SRe' } },
    SDD: { currency: { symbol: '£Sd' } },
    SEK: { currency: { symbol: 'SEK ' } },
    SGD: { currency: { symbol: 'S$' } },
    SHP: { currency: { symbol: 'SH£' } },
    SKK: { currency: { symbol: 'Sk' } },
    SLL: { currency: { symbol: 'Le' } },
    SOS: { currency: { symbol: 'Sh' } },
    SRD: { currency: { symbol: 'SR$' } },
    STD: { currency: { symbol: 'Db' } },
    SYP: { currency: { symbol: 'S£' } },
    SZL: { currency: { symbol: 'SZL ' } },
    THB: { currency: { symbol: '฿' } },
    TJS: { currency: { symbol: 'TJS ' } },
    TMM: { currency: { symbol: 'm' } },
    TND: { currency: { symbol: 'د.ت' } },
    TOP: { currency: { symbol: 'PT$' } },
    TRY: { currency: { symbol: '₺' } },
    TTD: { currency: { symbol: 'TT$' } },
    TWD: { currency: { symbol: 'NT$' } },
    TZS: { currency: { symbol: 'TSh' } },
    UAH: { currency: { symbol: '₴' } },
    UGX: { currency: { symbol: 'USh' } },
    USD: { currency: { symbol: 'US$' } },
    UYU: { currency: { symbol: 'UR$' } },
    UZS: { currency: { symbol: 'UZS ' } },
    VEB: { currency: { symbol: 'Bs' } },
    VND: { currency: { symbol: '₫' } },
    VUV: { currency: { symbol: 'Vt' } },
    WST: { currency: { symbol: 'WS$' } },
    XAF: { currency: { symbol: 'XAF ' } },
    XCD: { currency: { symbol: 'EC$' } },
    XOF: { currency: { symbol: 'XOF ' } },
    XPF: { currency: { symbol: 'CFP ' } },
    YER: { currency: { symbol: 'YER ' } },
    ZAR: { currency: { symbol: 'R' } },
    ZMK: { currency: { symbol: 'ZK' } },
    ZMW: { currency: { symbol: 'K' } },
    ZWD: { currency: { symbol: 'Z$' } },
    ZWL: { currency: { symbol: 'Z$' } }
};
exports.defaultLocale = {
    delimiters: {
        thousands: ',',
        decimal: '.'
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function () { return '.'; },
    currency: {
        symbol: ''
    }
};
/**
 * Create a string made up of the specified length of '0' characters.
 *
 * @param length The desired length (count of '0' characters in the result
 * string).
 */
function buildZeroString(length) {
    return new Array(length + 1).join('0');
}
exports.buildZeroString = buildZeroString;
/**
 * Determine whether or not a number is between -1 and 1.
 *
 * @param value The input value.
 */
function isTiny(value) {
    return value > -1 && value < 1;
}
exports.isTiny = isTiny;
/**
 * Determine whether the input value can be expressed as a valid finite number.
 *
 * @param value The input value.
 */
function isValidNumber(value) {
    return Number.isFinite(parseFloat(String(value)));
}
exports.isValidNumber = isValidNumber;
/**
 * Translate a value from one scale to another e.g. from millions to billions.
 *
 * @param value The input value.
 * @param from The origin scale.
 * @param to The target scale.
 */
function transposeScale(value, from, to) {
    if (from === void 0) { from = enums_1.Scale.Ones; }
    if (to === void 0) { to = enums_1.Scale.Ones; }
    return (value * from) / to;
}
exports.transposeScale = transposeScale;
